var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    externalResourcesRequired: "true"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    className: "bg-transparent w-screen max-w-full aspect-square md:w-[350px] md:h-[350px] lg:w-[400px] lg:h-[400px] xl:w-[600px] xl:h-[600px]",
    style: {
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box transparent",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 600,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 600,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 600,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "100%",
      maxWidth: "100%",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 40,
      padding: 40,
      paddingInline: 40,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "300px 300px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "300px 300px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "isolate",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 600,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgb(102, 147, 166)",
      borderRadius: 99,
      accentColor: "auto",
      placeContent: "normal center",
      placeItems: "center normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 520,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 99,
      borderEndStartRadius: 99,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 99,
      borderStartStartRadius: 99,
      inset: "auto",
      boxShadow: "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.1) 0px 8px 10px -6px",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "flex",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 520,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 520,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "hidden",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "260px 260px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "260px 260px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "isolate",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 520,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    className: "w-full aspect-square overflow-hidden flex justify-center items-center shadow-xl"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 0)",
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 400,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 400,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 400,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: "auto",
      minHeight: "auto",
      minInlineSize: "auto",
      minWidth: "auto",
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "200px 200px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transformOrigin: "200px 200px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 400,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 24 24",
    fill: "#ffffff",
    stroke: "rgb(253, 253, 253)",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-home",
    fillOpacity: 0,
    style: {
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 400,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 400,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 400,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: "content-box",
      overflowWrap: "normal",
      overflow: "hidden",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "200px 200px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(253, 253, 253)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: "1.95px",
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "200px 200px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "middle",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 400,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
    style: {
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(253, 253, 253)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: "1.95px",
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 22 9 12 15 12 15 22",
    style: {
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(253, 253, 253)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: "1.95px",
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9c3913b2fa58f79323d54d278918cf2b.svg";
export { ForwardRef as ReactComponent };